import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../iw-ui/core/auth";

function ChangePassword(props) {
    const history = useHistory();
    const { authTokens, setAuthTokens } = useAuth();

    const buttonSubbmitRef = useRef();

    const [error, setError] = useState();
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        buttonSubbmitRef.current.disabled = loading;
    }, [loading]);


    const onButtonCancelClick = () => {
        history.goBack();
    };

    const onSubmitClick = () => {

        if (oldPassword === "") {
            setError("Pole Aktualne hasło jest wymagane");
            return;
        }

        if (newPassword === "") {
            setError("Pole Nowe hasło jest wymagane");
            return;
        }



        if (newPassword !== confirmPassword) {
            setError("Nowe i powtórzone hasło nie pasują do siebie");
            return;
        }


        const url = `${process.env.REACT_APP_BASE_API_URL}/v1/manage/change_password`;
        const method = 'POST';
        const bearerToken = authTokens().access_token;

        let headers = { "Content-Type": "application/json" };
        if (bearerToken) {
            headers["Authorization"] = `Bearer ${bearerToken}`;
        }

        var data = {
            old_password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
        };

        setLoading(true);

        fetch(
            url, {
            method: method,
            headers: headers,
            body: JSON.stringify(data)
        }
        )
            .then((response) => {
                setLoading(false);
                if (response.status === 401) {
                    setAuthTokens();
                }
                if (response.status === 200) {
                    onButtonCancelClick();
                    return;
                }

                if (response.status === 422) {
                    return response.json();
                }
            })
            .then((result) => {
                if (result) {
                    //setError(result.Message);


                    if (result.Message !== undefined) {
                        setError(result.Message);
                    }
                    if (result.message !== undefined) {
                        setError(result.message);
                    }
                    // setOldPassword("");
                    // setNewPassword("");
                    // setNewPassword("");
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error:', error);
            }
            );

    }


    return (
        <div>
            <h2>Zmiana hasła</h2>

            <div className="form-horizontal">
                <h4>Formularz zmiany hasła</h4>
                <hr />
                {error && (
                    <div className="validation-summary-valid text-danger">
                        <ul>
                            <li>
                                {error}
                            </li>
                        </ul>
                    </div>
                )}
                <div className="form-group">
                    <label className="col-md-2 control-label" for="OldPassword">Aktualne hasło</label>
                    <div className="col-md-10">
                        <input
                            className="form-control"
                            type="password"
                            value={oldPassword}
                            onChange={e => {
                                setOldPassword(e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-group">
                    <label className="col-md-2 control-label" for="NewPassword">Nowe hasło</label>
                    <div className="col-md-10">
                        <input
                            className="form-control"
                            type="password"
                            value={newPassword}
                            onChange={e => {
                                setNewPassword(e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-group">
                    <label className="col-md-2 control-label" for="ConfirmPassword">Powt&#243;rz hasło</label>
                    <div className="col-md-10">
                        <input
                            className="form-control"
                            type="password"
                            value={confirmPassword}
                            onChange={e => {
                                setConfirmPassword(e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-md-offset-2 col-md-10">
                        <button className="btn btn-default" style={{ width: "100px" }} onClick={onSubmitClick} ref={buttonSubbmitRef}>
                            {!loading ? (
                                <span>Zmień hasło</span>
                            ) : (
                                <span class="glyphicon glyphicon-refresh gly-spin" aria-hidden="true"></span>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;